import { useObservable } from './rxjs';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CameraSubject } from 'streem-sdk-protobuf';
import { combineLatest } from 'rxjs';
/**
 * Returns the camera subjects for a given array of video controllers

 * @param videoControllers Takes an observable array of videoControllers: Observable<IVideoController[]>
 */
export function useCameraSubject(videoControllers) {
    const cameraSubjectsObservable = videoControllers.pipe(switchMap(controllers => {
        return combineLatest(controllers.map(controller => controller.cameraSubject));
    }), distinctUntilChanged((prev, curr) => prev === curr));
    const [cameraSubjects] = useObservable(cameraSubjectsObservable);
    return cameraSubjects || [];
}
export function hasWorldSubject(videoControllers) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCameraSubject(videoControllers).includes(CameraSubject.CAMERA_SUBJECT_WORLD);
}
export function hasScreenSubject(videoControllers) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCameraSubject(videoControllers).includes(CameraSubject.CAMERA_SUBJECT_SCREEN);
}
//# sourceMappingURL=use_camera_subject.js.map